export default "__VITE_ASSET__Rit3qD_b__"